module.exports = __webpack_public_path__ + "static/media/confirmation-animation.a26f54e8.svg";